import { Breadcrumb } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";

import { useNavigate, useLocation } from "react-router-dom";
import { switchCurrentBranch } from "@store/slice/current-slice";
import { breadcrumbs } from "./NewHeaderType";
import HeaderUserBranchCluster from "./HeaderUserBranchCluster";
import { Z_GLOBAL_OVERLAY } from "@constants/zIndex";
import { usesSalesFixedUserBranchSlotFromPath, shouldHideSalesHeaderUserBranchFromPath } from "../../pages/Sales/salesFixedUserBranchSlot";
import { confirmPageLeaveIfDirty } from "@helpers/pageLeaveGuard";

// 與 _new-header.scss、DefaultLayout 主欄 padding、.pims-page margin-left 對齊（請採驗麵包屑與導覽帶下方同左緣）
const NEW_HEADER_LEFT_CHROME_PX = 34 + 82;
const LAYOUT_MAIN_PADDING_SIDEBAR_OPEN_PX = 260;
const PIMS_PAGE_MARGIN_LEFT_PX = 110;

const NewHeader = ({
  renderBar,
  pagination,
  subPage,
  sidebarModal,
  menuBarList,
  routerName,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // 取分店
  const userInfo = useSelector((store) => {
    return store.user.user;
  });

  const branches = useMemo(
    () => userInfo?.brandInfo?.branches || [],
    [userInfo?.brandInfo?.branches]
  );

  const currentInfo = useSelector((store) => {
    return store.current;
  });
  const { branchId } = currentInfo;

  const subscribeBranches = useSelector(
    (state) => state.subscribe.subscribe.branches
  );

  const [hasNotDeduceBranch, setHasNotDeduceBranch] = useState(false);

  useEffect(() => {
    if (!!branchId) {
      dispatch(
        switchCurrentBranch({
          branchId: branchId,
          branchInfo: branches.find((branch) => {
            return branch.id === branchId;
          }),
        })
      );
    }
  }, [branchId, branches, dispatch]);

  useEffect(() => {
    const alertOrNot = subscribeBranches.some((i) => {
      const today = new Date().getTime() / 1000;
      return (
        i.next_deduction !== null &&
        today > i.next_deduction &&
        today < i.expire_time
      );
    });
    setHasNotDeduceBranch(alertOrNot);
  }, [subscribeBranches]);

  const mainContentPadPx =
    !menuBarList[routerName] ? 0 : sidebarModal ? LAYOUT_MAIN_PADDING_SIDEBAR_OPEN_PX : 0;

  const breadCrumbContainerStyle = (() => {
    const transition = "padding-left 0.5s ease 0s, margin-left 0.5s ease 0s";
    if (routerName === "pims") {
      const raw =
        mainContentPadPx + PIMS_PAGE_MARGIN_LEFT_PX - NEW_HEADER_LEFT_CHROME_PX;
      return {
        transition,
        paddingLeft: `${Math.max(0, raw)}px`,
        marginLeft: raw < 0 ? `${raw}px` : undefined,
      };
    }
    return {
      transition,
      paddingLeft: `${!menuBarList[routerName] ? 0 : sidebarModal ? 302 : 42}px`,
    };
  })();

  const hideSalesHeaderUserBranch =
    routerName === "sales" &&
    shouldHideSalesHeaderUserBranchFromPath(location.pathname);

  return (
    <div className={`new-header${routerName === "appointment" ? " new-header--appointment" : ""}`}>
      {hasNotDeduceBranch && (
        <div
          className='important-alert'
          style={{
            transition: "padding-left 0.5s ease 0s",
            paddingLeft: `${!menuBarList[routerName]
              ? "0px"
              : sidebarModal
                ? "400px"
                : "150px"
              }`,
          }}
          onClick={() => {
            confirmPageLeaveIfDirty(() => navigate("/options/serviceplan"));
          }}
        >
          <div
            onClick={() => {
              setHasNotDeduceBranch(false);
            }}
          >
            <ReactSVG
              src={process.env.PUBLIC_URL + "/assets/img/icon/cross.svg"}
            />
          </div>
          <div>
            {
              "很抱歉通知您，本期信用卡自動扣繳失敗，請儘速前往繳納帳款，以維護您的權益"
            }
            <div className='peta-arrow'></div>
          </div>
        </div>
      )}
      <div className='new-header-main d-flex justify-content-center align-items-center justify-content-md-between'>
        <div className="breadCrumb-container" style={breadCrumbContainerStyle}>
          {routerName === "pims" ? (
            <div
              id="pims-header-breadcrumb-root"
              className="pims-header-breadcrumb-root"
            />
          ) : routerName === "sales" ? null : (
            <Breadcrumb separator=">">
              {breadcrumbs(
                routerName,
                pagination,
                subPage,
                // 如果是分店帳號設定頁面，從 branches 中取得分店名稱
                routerName === "options" &&
                  pagination === "branch" &&
                  subPage &&
                  !isNaN(subPage)
                  ? branches.find(
                      (branch) =>
                        branch.id &&
                        (branch.id === parseInt(subPage, 10) ||
                          branch.id.toString() === subPage)
                    )?.branch_name
                  : null
              ).map((item, index) => (
                <Breadcrumb.Item key={index}>
                  {item.href ? (
                    <span
                      className="f-16"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        confirmPageLeaveIfDirty(() => navigate(item.href));
                      }}
                    >
                      {item.text}
                    </span>
                  ) : (
                    item.text
                  )}
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
          )}
          {routerName === "appointment" ? (
            <div
              id="appointment-header-period-nav-root"
              className="new-header__appointment-period-nav-root"
            />
          ) : null}
        </div>
        {!hideSalesHeaderUserBranch ? (
          <HeaderUserBranchCluster
            variant={routerName === "sales" ? "sales" : "default"}
          />
        ) : null}
      </div>
    </div>
  );
};

export default NewHeader;
